import * as yup from 'yup';

export const clustersSchema = (t) =>
  yup.object({
    clusterId: yup.number(),
    code: yup
      .string()
      .required(t('validationFieldRequired', { name: t('code') })),
    name: yup
      .string()
      .required(
        t('validationFieldRequired', {
          name: t('name')
        })
      )
      .default(''),
    description: yup.string()
  });
